module.exports = __webpack_public_path__ + "static/media/bonarka17.19341fc8.jpg";